import { render } from "./ShipyardFormInputFields.vue?vue&type=template&id=4e0f0446"
import script from "./ShipyardFormInputFields.vue?vue&type=script&lang=ts"
export * from "./ShipyardFormInputFields.vue?vue&type=script&lang=ts"
script.render = render

export default script